import React from 'react'
import styled from 'styled-components'

export interface EmptyOrderHistoryProps {
  className?: string
  message?: string
}

const EmptyOrderHistory: React.VFC<EmptyOrderHistoryProps> = ({ className, message }) => (
  <div className={className}>{message || 'No order history at the moment.'}</div>
)

const StyledEmptyOrderHistory = styled(EmptyOrderHistory)`
  color: #001b36;
  line-height: 30px;
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
`

export default StyledEmptyOrderHistory
